import React from 'react';
import cn from 'classname';
import { Tooltip as AntdTooltip, TooltipProps } from 'antd';
import styled from '@emotion/styled';
import classes from './Tooltip.module.scss';

const Tooltip = (
  props: Partial<TooltipProps> & {
    className?: any;
    isDark?: boolean;
  }
) => {
  const { className, isDark, ...rest } = props;
  return <AntdTooltip overlayClassName={cn({
    [classes.isDark]: isDark
  }, className)} {...rest}></AntdTooltip>;
};

const StyledAntdTooltip = styled(Tooltip)`
  .ant-tooltip-inner {
    background: #3a4861;
    box-shadow: 0px 24px 32px 0px #0000000d;
    box-shadow: 0px 8px 20px 0px #3a48610f;
    box-shadow: 0px 1px 5px 0px #3a48611a;
    border-radius: 6px;
  }
  .ant-tooltip-content {
    .ant-tooltip-arrow {
      > span {
        &:before {
          background: #3a4861;
        }
      }
    }
  }
`;
export default StyledAntdTooltip;
